// Checks a value is undefined.
export const isUndefined = (value) =>
  value === null || typeof value === "undefined";

// Checks a value is an object.
export const isObject = (val) => {
  if (val === null) {
    return false;
  }
  return typeof val === "function" || typeof val === "object";
};

// Checks a value is empty.
export const isEmpty = (value) => {
  if (isUndefined(value)) {
    return true;
  }
  if (typeof value === "string") {
    value = value.trim();
    return value === "";
  }
  if (typeof value === "number" && Number.isNaN(value)) {
    return true;
  }
  if (
    (Array.isArray(value) && value.length === 0) ||
    (value.constructor === Object && Object.keys(value).length === 0)
  ) {
    return true;
  }

  return false;
};

// Checks a value is numeric.
export const isNumeric = (n) => !Number.isNaN(n);

// Returns a string with random characters of the specified length.
export const getRandomString = (length) => {
  const randomChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i += 1) {
    result += randomChars.charAt(
      Math.floor(Math.random() * randomChars.length)
    );
  }
  return result;
};

// Returns an array of unique values.
export const uniqueArr = (arr) =>
  arr.sort().filter((item, pos, ary) => !pos || item !== ary[pos - 1]);

// Checks object has the specified property name.
export const hasOwnProp = (obj, propName) =>
  Object.prototype.hasOwnProperty.call(obj, propName);

// Deletes properties from an object and returns a new object.
export const omit = (obj, keys) => {
  const { ...rest } = obj;
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (key in rest) {
      delete rest[key];
    }
  }

  return rest;
};

// Picks properties from an object and returns a new object.
export const pick = (obj, fn) => {
  return Object.keys(obj).reduce((result, key) => {
    if (fn(obj[key])) {
      result[key] = obj[key];
    }
    return result;
  }, {});
};

// Parses the google address components resutls.
export const getAddressComponents = ({ address_components }) => {
  let streetNumber = "";
  let streetName = "";
  let city = "";
  let state = "";
  let zip = "";

  address_components.forEach((component) => {
    if (component.types.includes("street_number")) {
      streetNumber = `${component.long_name} `;
    } else if (component.types.includes("route")) {
      streetName = component.long_name;
    } else if (component.types.includes("sublocality")) {
      city = component.long_name;
    } else if (component.types.includes("locality")) {
      city = component.long_name;
    } else if (component.types.includes("administrative_area_level_1")) {
      state = component.short_name;
    } else if (component.types.includes("postal_code")) {
      zip = component.short_name;
    }
  });

  let address = "";
  if (streetNumber) {
    address = streetNumber;
  }
  if (streetName) {
    address += streetName;
  }

  return [address, city, state, zip];
};

/**
 * Forces browser to download a csv file.
 *
 * @param {Array.<String[]>} data
 * @param {String} fileName
 */
export const downloadCSV = (data, fileName) => {
  let csvData = "";
  if (Array.isArray(data)) {
    csvData = data.map((e) => e.join(",")).join("\n");
  } else {
    csvData = data;
  }

  const blobObject = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

  // Support for IE11
  if (window.navigator.msSaveBlob) {
    window.navigator.msSaveOrOpenBlob(blobObject, fileName);
  } else {
    const url = URL.createObjectURL(blobObject);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
